import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip as UDSTooltip } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const Tooltip = ({
  message: customMessage = '',
  icon = 'fa-question-circle',
  children
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { tooltipMessage }
  } = localizedStrings;

  return (
    <>
      {children}
      <UDSTooltip content={customMessage || tooltipMessage}>
        <div
          style={{ display: 'inline', marginLeft: '0.75rem', cursor: 'pointer' }}
        >
          <i className={`fa ${icon}`} />
        </div>
      </UDSTooltip>
    </>
  );
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  message: PropTypes.string,
  icon: PropTypes.string
};

export default Tooltip;
